import QRCode from 'qrcode';

// Encodes plain text (the booking's serialNo) into a QR image. Scanning it
// just reveals that text again — no network lookup involved, so this works
// even for a staff member who isn't logged into the admin app.
// 200px is already ~2.5x oversampled versus the ~80pt box it's displayed in
// on the slip — plenty sharp for scanning/print, without the extra encode
// time and data-URI size of the previous 300px version.
export async function generateQrDataUrl(payload) {
  return QRCode.toDataURL(String(payload), { margin: 1, width: 200 });
}
